import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';
import { Spring } from 'react-spring';
import { ToastContainer, toast, cssTransition } from 'react-toastify';

import { APIHandler, StorageHandler, BackVideo, DataHandler, ContentHeader } from 'C4';
import { storageKeys, bgVideo } from 'settings';
import logo from 'assets/images/logo/logoXpoPRO.png';
import 'react-toastify/dist/ReactToastify.css';

export default class LeaderboardView extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    // TODO
    // FOnts
    // Color
    // Profile menu
    // Videos
    // Logos
    // Benefits
    // Info hover / clcik

    // TODO titles to h1 or h2
  }

  render() {
    return (
      <div className="leaderboardView">
        <div className="gradient" />
        <div className="bg" />

        <div className="leaderboardHolder">

          <ContentHeader
            header="Prize Center"
            subtitle="Earn points from various activities across the show, compete with other attendees for prizes, as you surprise and delight element of the experience."
            icon="trophy"
          />

          <div className="board__holder">

            <div className="winners">
              <h3>Recent Winners:</h3>
              <ul>
                <li>
                  <img className="user__image" alt="user" src={jessica} />
                  <span>Jessica Messina</span>
                  <span className="company">Polestar Travel</span>
                </li>
                <li>
                  <hr />
                  <img className="user__image" alt="user" src="https://travpromobile.com/images/chris.png" />
                  <span>Chris van Workum</span>
                  <span className="company">Westway Travel</span>
                </li>
                <li>
                  <hr />
                  <img className="user__image" alt="user" src="https://travpromobile.com/images/frank.png" />
                  <span>Frank Sillen</span>
                  <span className="company">Clubman Travel</span>
                </li>
              </ul>
            </div>

            <div className="list">
              <h3>Leaderboard:</h3>
              <ol>
                <li className="first">
                  <div className="position">1.</div>
                  <div className="image__holder">
                    <img className="user__image" alt="user" src={jessica} />
                    <div className="badge">
                      <FontAwesomeIcon icon={['far', 'trophy']} />
                    </div>
                  </div>
                  <div className="user">Jessica Messina</div>
                  <div className="score">1550<span>xp</span></div>
                </li>
                <li className="second">
                  <div className="position">2.</div>
                  <div className="image__holder">
                    <img className="user__image" alt="user" src="https://travpromobile.com/images/frank.png" />
                    <div className="badge silver">
                      <FontAwesomeIcon icon={['far', 'trophy']} />
                    </div>
                  </div>
                  <div className="user">Frank Sillen</div>
                  <div className="score">1550<span>xp</span></div>
                </li>
                <li className="third">
                  <div className="position">3.</div>
                  <div className="image__holder">
                    <img className="user__image" alt="user" src="https://travpromobile.com/images/chris.png" />
                    <div className="badge bronze">
                      <FontAwesomeIcon icon={['far', 'trophy']} />
                    </div>
                  </div>
                  <div className="user">Chris van Workum</div>
                  <div className="score">1550<span>xp</span></div>
                </li>
                <li>
                  <div className="position">4.</div>
                  <img className="user__image" alt="user" src="https://travpromobile.com/images/jenn.png" />
                  <div className="user">Jennifer Belz</div>
                  <div className="score">1550<span>xp</span></div>
                </li>
                <li>
                  <div className="position">5.</div>
                  <img className="user__image" alt="user" src="https://front.travpromobile.com/614/user.jpg" />
                  <div className="user">John Doe</div>
                  <div className="score">1550<span>xp</span></div>
                </li>
                <li>
                  <div className="position">6.</div>
                  <img className="user__image" alt="user" src={blair} />
                  <div className="user">Blair Saba</div>
                  <div className="score">1550<span>xp</span></div>
                </li>
                <li>
                  <div className="position">7.</div>
                  <img className="user__image" alt="user" src="https://travpromobile.com/images/chris.png" />
                  <div className="user">Chris van Workum</div>
                  <div className="score">1550<span>xp</span></div>
                </li>
                <li>
                  <div className="position">8.</div>
                  <img className="user__image" alt="user" src={jessica} />
                  <div className="user">Jessica Messina</div>
                  <div className="score">1550<span>xp</span></div>
                </li>
                <li>
                  <div className="position">9.</div>
                  <img className="user__image" alt="user" src={blair} />
                  <div className="user">Blair Saba</div>
                  <div className="score">1550<span>xp</span></div>
                </li>
                <li>
                  <div className="position">10.</div>
                  <img className="user__image" alt="user" src="https://travpromobile.com/images/frank.png" />
                  <div className="user">Frank Sillen</div>
                  <div className="score">1550<span>xp</span></div>
                </li>
              </ol>

              <ol className="unranked__User">
                <h3>Your Position:</h3>
                <li>
                  <div className="position">34.</div>
                  <img className="user__image" alt="user" src="https://front.travpromobile.com/614/0.jpg" />
                  <div className="user">Jonathan Cooper</div>
                  <div className="score">70<span>xp</span></div>
                </li>
              </ol>
            </div>

            <div className="prizes">
              <h3>Prizes:</h3>
              <ul>
                <li>
                  <img className="company__image" alt="prize" src="https://www.festivalclaca.cat/pics/b/17/174568_amazon-logo-png-transparent-background.png" />
                  <span>1x $500 Gift Card</span>
                </li>
                <li>
                  <img className="company__image" alt="prize" src="https://www.festivalclaca.cat/pics/b/17/174568_amazon-logo-png-transparent-background.png" />
                  <span>5x $50 Amazon Gift Card</span>
                </li>
                <li>
                  <img className="company__image" alt="prize" src="https://www.festivalclaca.cat/pics/b/17/174568_amazon-logo-png-transparent-background.png" />
                  <span>10x $25 Starbucks Gift Card</span>
                </li>
              </ul>
              <a>Terms and Conditions apply*</a>
            </div>

            <div className="tentative">
              <h3>How to Earn XP&apos;s:</h3>
              <ul>
                <li>100<span>xp</span> register</li>
                <li>250<span>xp</span> Watch Keynote</li>
                <li>500<span>xp</span> per Breakout Session</li>
                <li>500<span>xp</span> per booth Visit (1x)</li>
                <li>250<span>xp</span> per chat in booth</li>
                <li>150<span>xp</span> per video in booth (watch) (1x)</li>
                <li>200<span>xp</span> per download/share in booth Brochures</li>
                <li>250<span>xp</span> share entire booth</li>
                <li>Training 500<span>xp</span> per module</li>
              </ul>
            </div>

          </div>

        </div>

        <div className="bottom__bar" />
      </div>
    );
  }
}
